import publicKeyPEM from '../data/publicKey.js';

async function importPublicKey(pemKey = publicKeyPEM, crypto = window.crypto) {
  const pemContents = pemKey.replace(/-----.*?-----/g, '').replace(/\s+/g, '');
  const binaryDer = Uint8Array.from(atob(pemContents), (c) => c.charCodeAt(0));

  return crypto.subtle.importKey(
    'spki',
    binaryDer.buffer,
    { name: 'RSA-OAEP', hash: 'SHA-256' },
    true,
    ['encrypt']
  );
}

async function importPrivateKey(pemKey, crypto = window.crypto) {
  const pemContents = pemKey.replace(/-----.*?-----/g, '').replace(/\s+/g, '');
  const binaryDer = Uint8Array.from(atob(pemContents), (c) => c.charCodeAt(0));

  return crypto.subtle.importKey(
    'pkcs8',
    binaryDer.buffer,
    { name: 'RSA-OAEP', hash: 'SHA-256' },
    true,
    ['decrypt']
  );
}

export async function encryptWithPublicKey(
  plaintext,
  publicKeyPEM,
  crypto = window.crypto
) {
  const publicKey = await importPublicKey(publicKeyPEM, crypto);
  const encodedPlaintext = new TextEncoder().encode(plaintext);

  const encryptedData = await crypto.subtle.encrypt(
    { name: 'RSA-OAEP' },
    publicKey,
    encodedPlaintext
  );

  return btoa(String.fromCharCode(...new Uint8Array(encryptedData)));
}

export async function decryptWithPrivateKey(
  encryptedBase64,
  privateKeyPEM,
  crypto = window.crypto
) {
  const privateKey = await importPrivateKey(privateKeyPEM, crypto);
  const encryptedData = Uint8Array.from(atob(encryptedBase64), (c) =>
    c.charCodeAt(0)
  );

  const decryptedData = await crypto.subtle.decrypt(
    { name: 'RSA-OAEP' },
    privateKey,
    encryptedData
  );

  return new TextDecoder().decode(decryptedData);
}
